import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { datadogLogger } from '../datadog/datadogLogger';
import { DDComponent } from '../datadog/setup';
import { checkShouldUseMocks } from '../envUtils';
import { responseErrorInterceptor } from './responseErrorInterceptor';
import { getPasetoAuthToken } from './utils';

/**
 * Used in B2C, B2B self services and EShop checkout only for authorized users
 */
const axiosWithPasetoAuth = axios.create({
    withCredentials: true,
    baseURL: checkShouldUseMocks() ? process.env.HUDSON_PUBLIC_URL : '',
});

axiosWithPasetoAuth.interceptors.request.use((config) => {
    config.headers['X-Request-ID'] = `${new Date().toISOString()}_${uuidv4()}`;
    config.headers['X-Request-Origin'] = window.location.href;

    return getPasetoAuthToken().then(({ accessToken }) => {
        config.headers.Authorization = `bearer ${accessToken}`;

        if (!accessToken) {
            const datadogLogs = datadogLogger();
            datadogLogs.warn('Request with undefined Paseto token', {
                config,
                component: DDComponent.AUTH,
            });
        }

        return config;
    });
});

axiosWithPasetoAuth.interceptors.response.use(
    (response) => response,
    responseErrorInterceptor(axiosWithPasetoAuth, getPasetoAuthToken),
);

export { axiosWithPasetoAuth };
